import type { Asset, LayoutMode, ListMode } from './types';

export const sortAssetsByDate = (assets: Asset[]): Asset[] =>
    [...assets].sort((a, b) => {
        if (!a.createdAt && !b.createdAt) return 0;
        if (!a.createdAt) return 1;
        if (!b.createdAt) return -1;
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });

// Self-contained "MMM d, yyyy" (e.g. "Jul 31, 2026") so the package doesn't
// pull in a date library for one format.
const CREATED_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
});

export const formatCreatedDate = (createdAt?: string): string => {
    if (!createdAt) return '';
    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) return '';
    return CREATED_DATE_FORMAT.format(date);
};

/** Stable id used in preview URLs/state: patientFileId for GCS files (survives
 *  re-listing), assetId otherwise. */
export const assetPreviewId = (asset: Asset): string =>
    asset.patientFileId ?? String(asset.assetId);

export const readStoredLayoutMode = (storageKey: string): LayoutMode => {
    const stored = localStorage.getItem(storageKey);
    return stored === 'grid' ? 'grid' : 'list';
};

export const readStoredListMode = (storageKey: string): ListMode => {
    const stored = localStorage.getItem(storageKey);
    return stored === 'date' ? 'date' : 'category';
};
